import React from "react";

const MapViewPopp = ({ data, data1, data2 }) => {

    return (
        <div className="w-full p-4 bg-white">
            <div className="text-center mb-4">
                <h2 className="text-lg font-bold">Room Type: {data1}</h2>
            </div>

            {data === 0 && (
                <div className="flex flex-col items-center space-y-1">
                    {Array.isArray(data2) && data2.length > 0 ? (
                        data2.map((item, index) => (
                            <div key={index} className="flex font-semibold text-gray-800 w-40 justify-between">
                                <span>{item.Space}</span>
                                <span>: {item.SpaceCount}</span>
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-500">No data available.</p>
                    )}
                </div>
            )}

            {data === 1 && (
                <div className="flex flex-col items-center space-y-1 mt-4">
                    {Array.isArray(data2) && data2.length > 0 ? (
                        data2.map((item, index) => (
                            <div key={index} className="flex font-semibold text-gray-800 w-40 justify-between">
                                <span>{item.Amenities}</span>
                                <span>: {item.AmenitiesCount}</span>
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-500">No data available.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default MapViewPopp;
